export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/credits.2639b564.svg","height":26,"width":24,"blurWidth":0,"blurHeight":0};